/**
 * @generated SignedSource<<d3fc618bc5d69b22fd705e6d61cdde60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useConfiguratorData_ConfiguratorDataQuery$variables = {
  id: string;
};
export type useConfiguratorData_ConfiguratorDataQuery$data = {
  readonly node: {
    readonly attributes?: ReadonlyArray<{
      readonly attributeCode: string | null;
      readonly description: string | null;
      readonly name: string | null;
      readonly options: ReadonlyArray<{
        readonly constraintExpression: {
          readonly op: string | null;
        } | null;
        readonly description: string | null;
        readonly imageUrl: string | null;
        readonly name: string | null;
        readonly optionCode: string | null;
        readonly optionID: number | null;
      } | null> | null;
      readonly pricings: ReadonlyArray<{
        readonly attributePricingID: number;
        readonly price: number;
        readonly selectedOptionID: number | null;
      } | null> | null;
    }>;
    readonly scenes?: ReadonlyArray<{
      readonly meshDesignEffects: ReadonlyArray<{
        readonly effectID: any;
        readonly meshID: any;
        readonly name: string | null;
      }>;
      readonly meshSides: ReadonlyArray<{
        readonly meshID: any;
        readonly sideID: number;
      }>;
    }>;
  } | null;
};
export type useConfiguratorData_ConfiguratorDataQuery = {
  response: useConfiguratorData_ConfiguratorDataQuery$data;
  variables: useConfiguratorData_ConfiguratorDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meshID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelScene",
  "kind": "LinkedField",
  "name": "scenes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelSceneMeshSide",
      "kind": "LinkedField",
      "name": "meshSides",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sideID",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelSceneMeshDesignEffect",
      "kind": "LinkedField",
      "name": "meshDesignEffects",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "effectID",
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributeCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionID",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionCode",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeExpression",
      "kind": "LinkedField",
      "name": "constraintExpression",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "op",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributePricing",
  "kind": "LinkedField",
  "name": "pricings",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributePricingID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedOptionID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConfiguratorData_ConfiguratorDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribute",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Model",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConfiguratorData_ConfiguratorDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Attribute",
                "kind": "LinkedField",
                "name": "attributes",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Model",
            "abstractKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7dd8ada7d031eac22b410c30f8393ab7",
    "id": null,
    "metadata": {},
    "name": "useConfiguratorData_ConfiguratorDataQuery",
    "operationKind": "query",
    "text": "query useConfiguratorData_ConfiguratorDataQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      scenes {\n        meshSides {\n          meshID\n          sideID\n        }\n        meshDesignEffects {\n          effectID\n          meshID\n          name\n        }\n      }\n      attributes {\n        name\n        attributeCode\n        description\n        options {\n          optionID\n          name\n          optionCode\n          description\n          imageUrl\n          constraintExpression {\n            op\n          }\n        }\n        pricings {\n          attributePricingID\n          selectedOptionID\n          price\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "27d894f52e148f8622b366fad1f05a44";

export default node;
